/** @format */

import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./CreateOrder.module.scss";
import commonStyle from "../common.module.scss";
import { numberToFinanceFormat } from "../../../../utils";
import InfoIcon from "../../../shared/icons/InfoIcon";
import CustomInput from "../../../custom/custom-input/CustomInput";
import CargoInsurance from "../../cargo-insurance/CargoInsurance";
import ToggleSwitchIcon from "../../../shared/icons/ToggleSwitchIcon";
import OrderCustomInput from "../../../CreateOrder/Input/OrderCustomInput";
import CustomSelectMulti from "../../../custom/custom-select/CustomSelectMulti";
import CustomSelect from "../../../custom/custom-select";
import OrdersDatePicker from "../../../orders/date-picker-new";
import OrdersSectionItemInfoColumn from "./OrdersSectionItemInfoColumn";
import { toast } from "react-toastify";
import {t} from "i18next";

const OrdersSectionItemPayment = ({
  title,
  withInsurance = false,
  priceDiscount = 0,
  price = '',
  onSubmit,
  changeInput,
  defaultCount,
  onPriceChange,
  algoPrice,
  errorText = "",
  queryInsurance,
  declaredPrice,
  calcInsurance,
  fileInvoice,
  setInvoiceFile,
  saveDraft,
  partners,
  setPartner,
  partner,
  isTender,
  setIsTender,
  isPartner,
  setIsPartner,
  errorTextPartner,
  tenderDateEnd,
  tenderStartTime,
  tenderEndTime,
  setTenderDateEnd,
  setTenderStartTime,
  setTenderEndTime,
  minPickDate,
  errorDateTender,
  errorTimeStartTender,
  errortimeEndTender,
  partnersForTender,
  setPartnersForTender,
  errorTextPartners,
  user,
}) => {
  const [count, setCount] = useState(defaultCount);

  const incrementCount = () => {
    setCount(count + 1);
  };

  const decrementCount = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  useEffect(() => {
    if (count !== defaultCount && changeInput) {
      changeInput(count);
    }
  }, [count]);

  const handleToggleTender = () => {
    if (user && !user.permissions?.includes("tender_view")) {
      toast.info("Упс! Кажется, у вас нет доступа к этой функции. Позвоните в отдел продаж: +7 775 007 53 98", {
        autoClose: 10000
      });
      return;
    }

    if (!isTender) {
      setIsPartner(false);
      setPartner([]);
    }

    if (isTender) {
      setPartnersForTender([]);
      setTenderDateEnd();
      setTenderStartTime();
      setTenderEndTime();
    }

    setIsTender(!isTender);
  };

  const handleTogglePartner = () => {
    if (user && !user.permissions?.includes("expeditor_view")) {
      toast.info("Упс! Кажется, у вас нет доступа к этой функции. Позвоните в отдел продаж: +7 775 007 53 98", {
        autoClose: 10000
      });
      return;
    }
    if (!isPartner) {
      setIsTender(false);
      setPartnersForTender([]);
      setTenderDateEnd();
      setTenderStartTime();
      setTenderEndTime();
    }
    if (isPartner) {
      setPartner([]);
    }

    setIsPartner(!isPartner);
  };

  const totalPrice = () => {
    const priceValue = price === '' ? 0 : Number(price);
    const discountValue = priceDiscount === '' ? 0 : Number(priceDiscount);
    return priceValue + discountValue;
  };


  return (
    <>
      <div className={commonStyle.createOrderContainer}>
        <div className={commonStyle.createOrderContainer_price}>
          <div className={commonStyle.algo}>
            <InfoIcon width="20px" height="20px" />

            {algoPrice ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className={commonStyle.typography_large}>
                  {numberToFinanceFormat(algoPrice)} ₸
                </span>
                <span className={commonStyle.typography_regular}>{title}</span>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className={commonStyle.typography_large}>{t('priceUndefined')}</span>
                <span
                  className={commonStyle.typography_regular}
                  style={{ color: "#FF8502" }}
                >
                  {t('fillAllFieldsToCalc')}
                </span>
              </div>
            )}
          </div>
          <div style={{ flex: "1" }}>
            <CustomInput
                labelText={t('cargoTransportationPrice')}
                placeholder={t('addYourSum')}
                errorText={errorText}
                isBgGray={true}
                prefixEnd={<span>〒</span>}
                inputType="text"
                value={price || ''}
                onChangeValue={(item) => {
                  const numericValue = item.replace(/\D/g, '');
                  if (numericValue !== '0') {
                    onPriceChange(numericValue);
                  } else if (numericValue === '' || numericValue === null) {
                    onPriceChange('');
                  }
                }}
            />
          </div>
        </div>

        <div className={cn(commonStyle.checkbox_wrapper)}>
          <div className={commonStyle.checkbox_content}>
            <p>{t('orderDuplicate')}</p>
            <span>{t('orderDuplicateQuantity')}</span>
          </div>
          <div className={styles["createOrder__amount-count"]}>
            <button
              className={styles["createOrder__amount-button"]}
              onClick={decrementCount}
            >
              -
            </button>
            <OrderCustomInput
              value={count}
              onChange={(e) => setCount(parseInt(e.target.value) || 1)}
            />
            <button
              className={styles["createOrder__amount-button"]}
              onClick={incrementCount}
            >
              +
            </button>
          </div>
        </div>

        <CargoInsurance
          defaultValue={withInsurance}
          onClick={queryInsurance}
          declaredPrice={declaredPrice}
          setDeclaredPrice={calcInsurance}
          fileInvoice={fileInvoice}
          setInvoiceFile={setInvoiceFile}
          detect={saveDraft}
        />

        <div className={cn(commonStyle.checkbox_wrapper)}>
          <div className={commonStyle.checkbox_content}>
            <p>{t('tenderAnnounce')}</p>
            <span>{t('tenderAnnounceText')}</span>
          </div>
          <div className={cn(commonStyle.checkbox_switch)} onClick={handleToggleTender}>
            {isTender ? <ToggleSwitchIcon type={1} /> : <ToggleSwitchIcon type={0} />}
          </div>
        </div>

        {isTender && (
          <>
            <CustomSelectMulti
              labelText={t('chooseTC')}
              placeholder={t('choseCompany')}
              errorText={errorTextPartners}
              options={partners}
              defaultValue={partnersForTender}
              onSubmit={(item) => {
                setPartnersForTender(item);
              }}
              returnObject
              isMulti
            />

            <OrdersSectionItemInfoColumn contentGridColumn={"1fr 1.3fr"}>
              <OrdersDatePicker
                date={tenderDateEnd}
                timeStart={tenderStartTime}
                timeEnd={tenderEndTime}
                minDate={minPickDate}
                isSender
                isEditable
                setDate={setTenderDateEnd}
                setTimeStart={setTenderStartTime}
                setTimeEnd={setTenderEndTime}
                labelText={t('tenderEndDate')}
                labelTimeStart={t('ordersCreate.view.label.time')}
                labelTimeEnd={t('ordersCreate.view.label.timeUntil')}
                placeholderText={t('ordersCreate.view.placeholder.enterDate')}
                errorDate={errorDateTender}
                errorTimeStart={errorTimeStartTender}
                errortimeEnd={errortimeEndTender}
              />
            </OrdersSectionItemInfoColumn>
          </>
        )}

        <div className={commonStyle.checkbox_wrapper}>
          <div className={commonStyle.checkbox_content}>
            <p>{t('chooseTC')}</p>
            <span>{t('assignRequestToCompany')}</span>
          </div>
          <div className={cn(commonStyle.checkbox_switch)} onClick={handleTogglePartner}>
            {isPartner ? <ToggleSwitchIcon type={1} /> : <ToggleSwitchIcon type={0} />}
          </div>
        </div>

        {isPartner && (
          <CustomSelect
            labelText={t('chooseTC')}
            placeholder={t('choseCompany')}
            errorText={errorTextPartner}
            options={partners}
            defaultValue={partner}
            onSubmit={(item) => {
              setPartner(item);
            }}
            returnObject
          />
        )}

        <div className={commonStyle.all_price}>
          <div className={commonStyle.cargo}>
            <span className={commonStyle.typography_small}>{t('transportationPrice')}</span>
            <div className={cn(commonStyle.cargo_price, commonStyle.typography_small)}>
              {price === '' ? 0 : price} 〒
            </div>
          </div>
          <div className={commonStyle.cargo}>
            <span className={commonStyle.typography_small}>{t('cargoInsurancePrice')}</span>
            <div className={cn(commonStyle.cargo_price, commonStyle.typography_small)}>
              {priceDiscount} 〒
            </div>
          </div>
          <div className={commonStyle.cargo}>
            <span className={commonStyle.typography_medium}>{t('totalPrice')}</span>
            <div className={cn(commonStyle.cargo_price, commonStyle.typography_medium)}>
              {totalPrice()} 〒
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrdersSectionItemPayment;
